import React from "react";
import { templateActions, templateStore } from "../../templateStore";
import { useSnapshot } from "valtio";
import { store } from "../../Website/CoverPage/store";
import { Swiper, SwiperSlide } from "swiper/react";
import InformationIcon from "@components/Common/SvgIcons/InformationIcon";
import { t } from "i18next";
import { useFetchGlobal } from "../../../../../../api/hooks";

function BestProductPreview({ boutique, id_franshise, shopId }: any) {
    const { fetchGlobal } = useFetchGlobal();

    const { selectedLanguage } = useSnapshot(store);
    const snap = useSnapshot(templateStore);
    function getNestedValue(
        path: string[],
        field: string,
        lang: string,
        obj: any,
        isMultilingual: boolean = true
    ): any {
        try {
            let current = obj;
            for (const key of path) {
                if (current[key] === undefined) return "";
                current = current[key];
            }
            if (!current[field]) return "";
            return isMultilingual ? current[field][lang] || "" : current[field];
        } catch {
            return "";
        }
    }

    const Title = React.useMemo(() => {
        return getNestedValue(
            ["Application", "LaindingPage", boutique, "BestProducts"],
            "Title",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, boutique]);
    const [productsData, setProductsData] = React.useState<any[]>([]);

    const currentProducts = React.useMemo(() => {
        return (
            templateActions.getNestedObject([
                "template",
                "Application",
                "LaindingPage",
                boutique,
                "BestProducts",
                "Products",
            ]) || []
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [snap.template, boutique]);

    const mainColor = templateActions.getNestedObject([
        "template",
        "Application",
        "Divers",
        "CouleurPrincipale",
    ]);
    React.useEffect(() => {
        const bestProductsLoading = async () => {
            try {
                const result = await fetchGlobal<any>(
                    `${process.env.REACT_APP_CATALOGUE_ARTICLES}${id_franshise}/${shopId}`,
                    { method: "GET" }
                );
                setProductsData(result.data || []);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                templateActions.setLoading(false);
            }
        };
        bestProductsLoading();
        // eslint-disable-next-line
    }, [id_franshise, shopId]);

    const productsWithImages = React.useMemo(() => {
        return currentProducts
            .map((product: any) => {
                const productData = productsData.find(
                    (p: any) => p.Référence === product.Referance
                );
                return {
                    ...product,
                    imageUrl: productData?.Image || "",
                    Désignation: productData?.Désignation || "",
                };
            })
            .filter((product: any) => product.imageUrl);
    }, [currentProducts, productsData]);

    return (
        <div style={{ padding: "10px" }}>
            {productsWithImages.length > 0 && (
                <>
                    {" "}
                    <h6
                        style={{
                            padding: "8px 0px",
                            margin: 0,
                        }}
                    >
                        {Title}
                    </h6>
                    <Swiper
                        loop={false}
                        grabCursor={true}
                        mousewheel={true}
                        slidesPerView={"auto"}
                        spaceBetween={20}
                        className="swiper-container"
                        style={{ padding: "10px 0px" }}
                    >
                        {productsWithImages.map(
                            (item: any, index: number) =>
                                item.Activer === true && (
                                    <SwiperSlide
                                        key={index}
                                        style={{
                                            userSelect: "none",
                                            WebkitUserSelect: "none",
                                            MozUserSelect: "none",
                                            msUserSelect: "none",
                                            width: "150px",

                                            height: "200px",
                                            boxShadow:
                                                "12px 12px 12px rgba(187, 177, 177, 0.7)",
                                            borderRadius: "12px",
                                            overflow: "hidden",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            backgroundColor: "#fff",
                                            zIndex: 1,
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "100%",
                                                height: "100px",
                                                position: "relative",
                                            }}
                                        >
                                            {item.imageUrl ? (
                                                <img
                                                    src={item.imageUrl}
                                                    alt=""
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        borderBottomLeftRadius:
                                                            "12px",
                                                        borderBottomRightRadius:
                                                            "12px",
                                                        objectFit: "fill",
                                                        backgroundColor: `${
                                                            mainColor + "30"
                                                        }`,
                                                    }}
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        borderBottomLeftRadius:
                                                            "12px",
                                                        borderBottomRightRadius:
                                                            "12px",
                                                        backgroundColor: `${
                                                            mainColor + "30"
                                                        }`,
                                                    }}
                                                ></div>
                                            )}
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    right: "8px",
                                                    top: "8px",
                                                    backgroundColor: `${mainColor}`,
                                                    width: "25px",
                                                    height: "25px",
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <InformationIcon
                                                    width={15}
                                                    height={15}
                                                    fill="white"
                                                />
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                padding: "8px",
                                                flexGrow: 1,
                                            }}
                                        >
                                            <p
                                                style={{
                                                    textAlign: "center",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    margin: "4px 0 10px",
                                                    height: "40px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {item.Désignation}
                                            </p>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <button
                                                    disabled={true}
                                                    style={{
                                                        width: "100%",
                                                        padding: "6px",
                                                        fontSize: "13px",
                                                        backgroundColor:
                                                            "white",
                                                        color: `${mainColor}`,
                                                        border: `1px solid ${mainColor}`,
                                                        borderRadius: "6px",
                                                        transition:
                                                            "background-color 0.2s",
                                                    }}
                                                >
                                                    {t("To order")}
                                                </button>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                        )}
                    </Swiper>
                </>
            )}
        </div>
    );
}

export default BestProductPreview;
